import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from "@angular/core"

@Component({
  selector: "lex-modal",
  templateUrl: "./lex-modal.component.html",
  styleUrls: ["./lex-modal.component.css"],
})
export class LexModalComponent implements AfterViewInit {
  @ViewChild("wrapper") wrapper: ElementRef<HTMLDivElement>

  @Input() containerStyle = ""

  modalIsVisible = false

  open() {
    this.modalIsVisible = true
  }

  close() {
    this.modalIsVisible = false
  }

  ngAfterViewInit() {
    if (!this.wrapper.nativeElement) return

    this.wrapper.nativeElement.setAttribute("style", this.containerStyle)
  }
}
